import { Modal } from '@/shared/ui';

import { Button } from '../../../../shared/ui/Button/Button';

export const PublishModal = ({
  isOpen,
  onClose,
  onSubmit,
}: {
  isOpen?: boolean;
  onClose: () => void;
  onSubmit: () => void;
}) => {
  return (
    <Modal opened={isOpen} onClose={onClose}>
      <div
        className={
          'flex w-[522px] flex-col items-center justify-center gap-[32px]'
        }
      >
        <div className={'flex flex-col items-center justify-center gap-[16px]'}>
          <h2 className={'text-[32px] font-medium leading-[40px] text-black'}>
            Опубликовать компанию?
          </h2>
        </div>
        <div className={'flex w-[360px] flex-col gap-[16px]'}>
          <Button data-testid={'button-submit'} onClick={onSubmit}>
            Опубликовать
          </Button>
          <Button
            data-testid={'button-cancel'}
            onClick={onClose}
            variant={'link'}
          >
            Отмена
          </Button>
        </div>
      </div>
    </Modal>
  );
};
